import { UPDATE_DMX_DEVICE, UPDATE_DMX_DEVICE_SUCCESSFUL, UPDATE_DMX_DEVICE_FAILED } from './actionTypes';

export const updateDmxDevice = (device) => {
  return {
    type: UPDATE_DMX_DEVICE,
    payload: { device },
  };
};

export const updateDmxDeviceSuccessful = (message) => {
  return {
    type: UPDATE_DMX_DEVICE_SUCCESSFUL,
    payload: message,
  };
};

export const updateDmxDeviceFailed = (message) => {
  return {
    type: UPDATE_DMX_DEVICE_FAILED,
    payload: message,
  };
};
